import AdminRequestedVasps from './AdminRequestedVasps'

export default AdminRequestedVasps
